export class ComplainantGeneral {
    get id() {
        return this.complainantGeneralState.id;
    }
    get userId() {
        return this.complainantGeneralState.complainantThirId;
    }
    get diligenceNumber() {
        return this.complainantGeneralState.diligenceNumber;
    }
    get complainantThirId() {
        return this.complainantGeneralState.complainantThirId;
    }
    get showPartCause() {
        return this.complainantGeneralState.showPartCause;
    }
    get resignationRestitutionCause() {
        return this.complainantGeneralState.resignationRestitutionCause;
    }
    get resignationRepairDamage() {
        return this.complainantGeneralState.resignationRepairDamage;
    }
    get indemnificationWaiver() {
        return this.complainantGeneralState.indemnificationWaiver;
    }
    get appointsLawyer() {
        return this.complainantGeneralState.appointsLawyer;
    }
    get freeJustice() {
        return this.complainantGeneralState.freeJustice;
    }
    get vehicleId() {
        return this.complainantGeneralState.vehicleId;
    }
    get lawyerPart() {
        return this.complainantGeneralState.lawyerPart;
    }
    get suspectSomeone() {
        return this.complainantGeneralState.suspectSomeone;
    }
    get denouncePreviously() {
        return this.complainantGeneralState.denouncePreviously;
    }
    get vehicleDamage() {
        return this.complainantGeneralState.vehicleDamage;
    }
    get trailerPlate() {
        return this.complainantGeneralState.trailerPlate;
    }
    get ownsSecurity() {
        return this.complainantGeneralState.ownsSecurity;
    }
    get drivingLicense() {
        return this.complainantGeneralState.drivingLicense;
    }
    get licenseExpiration() {
        return this.complainantGeneralState.licenseExpiration;
    }
    set diligenceNumber(diligenceNumber) {
        this.complainantGeneralState.diligenceNumber = diligenceNumber;
    }
    set complainantThirId(diligenceNumber) {
        this.complainantGeneralState.diligenceNumber = diligenceNumber;
    }
    set showPartCause(showPartCause) {
        this.complainantGeneralState.showPartCause = showPartCause;
    }
    set resignationRestitutionCause(resignationRestitutionCause) {
        this.complainantGeneralState.resignationRestitutionCause = resignationRestitutionCause;
    }
    set indemnificationWaiver(indemnificationWaiver) {
        this.complainantGeneralState.indemnificationWaiver = indemnificationWaiver;
    }
    set appointsLawyer(appointsLawyer) {
        this.complainantGeneralState.appointsLawyer = appointsLawyer;
    }
    set freeJustice(freeJustice) {
        this.complainantGeneralState.freeJustice = freeJustice;
    }
    set vehicleId(vehicleId) {
        this.complainantGeneralState.vehicleId = vehicleId;
    }
    set lawyerPart(lawyerPart) {
        this.complainantGeneralState.lawyerPart = lawyerPart;
    }
    set suspectSomeone(suspectSomeone) {
        this.complainantGeneralState.suspectSomeone = suspectSomeone;
    }
    set denouncePreviously(suspectSomeone) {
        this.complainantGeneralState.suspectSomeone = suspectSomeone;
    }
    set vehicleDamage(vehicleDamage) {
        this.complainantGeneralState.vehicleDamage = vehicleDamage;
    }
    set trailerPlate(trailerPlate) {
        this.complainantGeneralState.trailerPlate = trailerPlate;
    }
    set ownsSecurity(ownsSecurity) {
        this.complainantGeneralState.ownsSecurity = ownsSecurity;
    }
    set resignationRepairDamage(resignationRepairDamage) {
        this.complainantGeneralState.resignationRepairDamage = resignationRepairDamage;
    }
    set drivingLicense(drivingLicense) {
        this.complainantGeneralState.drivingLicense = drivingLicense;
    }
    set licenseExpiration(licenseExpiration) {
        this.complainantGeneralState.licenseExpiration = licenseExpiration;
    }
    constructor(complainantGeneralState) {
        this.complainantGeneralState = complainantGeneralState;
    }
    getState() {
        return this.complainantGeneralState;
    }
}
